/* Homepage redesign (hp-* sections): hero slider, product tabs, persona tabs, rolling words, reviews, brand marquee. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Pause/play button (WCAG 2.2.2). Calls onChange(paused) and keeps its label in sync.
  function pauseButton(root, onChange, startPaused) {
    var btn = root.querySelector('[data-hp-pause]');
    if (!btn) return { paused: function () { return !!startPaused; } };
    var paused = !!startPaused;
    function sync() {
      btn.setAttribute('aria-pressed', paused);
      btn.setAttribute('aria-label', paused ? btn.getAttribute('data-play') : btn.getAttribute('data-pause'));
      btn.classList.toggle('is-paused', paused);
      onChange && onChange(paused);
    }
    btn.addEventListener('click', function () { paused = !paused; sync(); });
    sync();
    return { paused: function () { return paused; } };
  }

  // Auto-advance that stops while the shopper hovers or focuses inside, after they interact, or when paused.
  function autoplay(root, ms, step) {
    var last = 0, hold = false;
    root.addEventListener('mouseenter', function () { hold = true; });
    root.addEventListener('mouseleave', function () { hold = false; });
    root.addEventListener('focusin', function () { hold = true; });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) hold = false; });
    var btn = pauseButton(root, null, reduce);
    setInterval(function () {
      if (!hold && !btn.paused() && Date.now() - last > ms && !document.hidden) step();
    }, ms);
    return { touch: function () { last = Date.now(); } };
  }

  // Hero slider: one banner at a time. The active dot's progress bar is the timer; when it fills, the next banner slides in.
  // Hover, keyboard focus or the pause button freeze the bar (and so the slider).
  function hero(root) {
    var box = root.querySelector('.hp-hc');
    if (!box) return;
    var track = box.querySelector('.hp-hc__track');
    var slides = track.children, dots = box.querySelectorAll('.hp-hc__dot'), n = slides.length, cur = 0;
    if (n < 2) return;
    function go(i) {
      cur = (i + n) % n;
      track.style.transform = 'translateX(-' + cur * 100 + '%)';
      Array.prototype.forEach.call(slides, function (s, j) { if (j === cur) s.removeAttribute('inert'); else s.setAttribute('inert', ''); });
      dots.forEach(function (d, j) {
        var on = j === cur;
        d.classList.toggle('is-on', on);
        if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        // Restart the progress animation on the new active dot.
        var f = d.querySelector('.hp-hc__fill');
        f.style.animation = 'none'; void f.offsetWidth; f.style.animation = '';
      });
    }
    dots.forEach(function (d, j) {
      d.addEventListener('click', function () { go(j); });
      d.querySelector('.hp-hc__fill').addEventListener('animationend', function () { if (j === cur) go(cur + 1); });
    });
    var prev = box.querySelector('[data-hc-prev]'), next = box.querySelector('[data-hc-next]');
    prev && prev.addEventListener('click', function () { go(cur - 1); });
    next && next.addEventListener('click', function () { go(cur + 1); });
    function hold(on) { box.classList.toggle('is-held', on); }
    box.addEventListener('mouseenter', function () { hold(true); });
    box.addEventListener('mouseleave', function () { hold(box.contains(document.activeElement)); });
    box.addEventListener('focusin', function () { hold(true); });
    box.addEventListener('focusout', function (e) { if (!box.contains(e.relatedTarget)) hold(false); });
    pauseButton(box, function (p) { box.classList.toggle('is-paused', p); }, reduce);
    // Swipe on touch screens.
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
    });
    go(0);
  }

  // Tabs (WAI-ARIA pattern): click or arrow keys switch the panel.
  function ftabs(root) {
    var tabsEls = root.querySelectorAll('[role="tab"]'), panels = root.querySelectorAll('[role="tabpanel"]');
    var pills = root.querySelector('.hp-pills'), ind = pills && pills.querySelector('.hp-pills__ind'), cur = 0;
    // Carousel arrows: scroll the visible tab's cards one card at a time; hidden when every card already fits.
    var nav = root.querySelector('[data-ft-nav]');
    var prev = nav && nav.querySelector('[data-ft-prev]'), next = nav && nav.querySelector('[data-ft-next]');
    function grid() { var p = panels[cur] || root; return p.querySelector('.hp-ft__grid'); }
    function syncNav() {
      var g = grid();
      if (!nav || !g) return;
      var max = g.scrollWidth - g.clientWidth - 2;
      nav.classList.toggle('is-static', max <= 0);
      prev.disabled = g.scrollLeft <= 2;
      next.disabled = g.scrollLeft >= max;
    }
    function scrollCards(dir) {
      var g = grid(), c = g && g.querySelector('.hp-ft__item');
      if (c) g.scrollBy({ left: dir * c.offsetWidth });
    }
    if (nav) {
      prev.addEventListener('click', function () { scrollCards(-1); });
      next.addEventListener('click', function () { scrollCards(1); });
      root.querySelectorAll('.hp-ft__grid').forEach(function (g) { g.addEventListener('scroll', syncNav, { passive: true }); });
      window.addEventListener('resize', syncNav);
      syncNav();
    }
    // Slide the navy highlight under the chosen tab (instant on first paint and on resize)
    function moveInd(instant) {
      if (!ind || !tabsEls[cur]) return;
      var t = tabsEls[cur];
      if (instant) ind.style.transition = 'none';
      ind.style.width = t.offsetWidth + 'px';
      ind.style.transform = 'translateX(' + t.offsetLeft + 'px)';
      if (instant) { void ind.offsetWidth; ind.style.transition = ''; }
    }
    function select(j, focus) {
      if (j === cur && !focus) return;
      cur = j;
      tabsEls.forEach(function (t, k) { t.setAttribute('aria-selected', k === j); t.tabIndex = k === j ? 0 : -1; });
      panels.forEach(function (p, k) {
        p.hidden = k !== j;
        if (k === j) { p.classList.remove('is-in'); void p.offsetWidth; p.classList.add('is-in'); }
      });
      moveInd(false);
      syncNav();
      if (focus) tabsEls[j].focus();
    }
    if (ind) {
      pills.classList.add('has-ind');
      moveInd(true);
      window.addEventListener('resize', function () { moveInd(true); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { moveInd(true); });
    }
    tabsEls.forEach(function (t, j) {
      t.addEventListener('click', function () { select(j); });
      t.addEventListener('keydown', function (e) {
        var n = tabsEls.length, k = null;
        if (e.key === 'ArrowRight') k = (j + 1) % n;
        else if (e.key === 'ArrowLeft') k = (j - 1 + n) % n;
        else if (e.key === 'Home') k = 0;
        else if (e.key === 'End') k = n - 1;
        if (k !== null) { e.preventDefault(); select(k, true); }
      });
    });
  }

  // Rolls through the words on a loop (the last item repeats the first, so the jump back is invisible).
  // Stays still only for visitors whose device asks for reduced motion.
  function roll(root) {
    var list = root.querySelector('.hp-roll__list');
    if (!list || reduce) return;
    var words = list.children.length - 1, i = 0;
    setInterval(function () {
      if (document.hidden) return;
      i++;
      list.style.transition = '';
      list.style.transform = 'translateY(-' + i * 1.5 + 'em)';
      if (i >= words) {
        setTimeout(function () { list.style.transition = 'none'; list.style.transform = 'translateY(0)'; i = 0; }, 750);
      }
    }, 2400);
  }

  function tabs(root) {
    var btns = root.querySelectorAll('.hp-tab'), panels = root.querySelectorAll('.hp-why__panel');
    btns.forEach(function (b, j) {
      b.addEventListener('click', function () {
        btns.forEach(function (x, k) { x.setAttribute('aria-pressed', k === j); });
        panels.forEach(function (p, k) { p.hidden = k !== j; });
      });
    });
  }

  function reviews(root) {
    var track = root.querySelector('.hp-rev__track');
    if (!track) return;
    var cards = track.children, cur = 0;
    function step() { return cards[0] ? cards[0].offsetWidth : 320; }
    function max() {
      var view = track.parentElement.clientWidth;
      return Math.max(0, cards.length - Math.max(1, Math.floor(view / step())));
    }
    // Moves by scrolling the clipped viewport, so the browser's own scroll-into-view on keyboard focus agrees with it.
    var view = track.parentElement;
    function go(i, wrap, instant) {
      var m = max();
      cur = i > m ? (wrap ? 0 : m) : i < 0 ? (wrap ? m : 0) : i;
      view.scrollTo({ left: cur * step(), behavior: reduce || instant ? 'auto' : 'smooth' });
    }
    view.addEventListener('scroll', function () { cur = Math.round(view.scrollLeft / step()); }, { passive: true });
    // Keyboard focus on a card that is out of view brings it in.
    Array.prototype.forEach.call(cards, function (c, j) {
      c.addEventListener('focusin', function () {
        var v = view.getBoundingClientRect(), r = c.getBoundingClientRect();
        if (r.left < v.left - 1 || r.right > v.right + 1) go(j, false, true);
      });
    });
    var phone = window.matchMedia('(max-width: 749px)');
    var ap = autoplay(root, 7000, function () { if (!phone.matches) go(cur + 1, true); });
    var prev = root.querySelector('[data-rev-prev]'), next = root.querySelector('[data-rev-next]');
    prev && prev.addEventListener('click', function () { go(cur - 1, true); ap.touch(); });
    next && next.addEventListener('click', function () { go(cur + 1, true); ap.touch(); });
    window.addEventListener('resize', function () { go(cur); });
  }

  // Phone: show the first N categories, with a button to expand/collapse the rest.
  function catmore(root) {
    var box = root.querySelector('.hp-cg'), btn = root.querySelector('.hp-cg__more');
    if (!box || !btn) return;
    var n = parseInt(box.getAttribute('data-mobile-count'), 10) || 4;
    var cards = box.querySelectorAll('.hp-cg__card');
    cards.forEach(function (c, i) { if (i >= n) c.classList.add('is-extra'); });
    var label = btn.querySelector('.hp-cg__more-text');
    function set(open) {
      box.classList.toggle('is-collapsed', !open);
      btn.setAttribute('aria-expanded', open);
      label.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
    }
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      set(open);
      // Expanding: move focus to the first newly shown category. Collapsing: keep the button in view.
      if (open) { var first = cards[n]; first && first.focus(); }
      else btn.scrollIntoView({ block: 'nearest' });
    });
    set(false);
  }

  // Blog carousel: native scroll-snap; arrows move one card and disable at the ends.
  function blog(root) {
    var list = root.querySelector('.hp-blog__grid');
    var prev = root.querySelector('[data-blog-prev]'), next = root.querySelector('[data-blog-next]');
    if (!list || !prev || !next) return;
    function step() { var c = list.querySelector('.hp-blog__slide'); return c ? c.offsetWidth + 20 : list.clientWidth; }
    function sync() {
      var max = list.scrollWidth - list.clientWidth - 2;
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { list.scrollBy({ left: -step() }); });
    next.addEventListener('click', function () { list.scrollBy({ left: step() }); });
    list.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  // "Why ___ trust Joto": swap the coral word every 1.5s with a short fade-up (still for reduced-motion visitors)
  function trustroll(root) {
    var el = root.querySelector('.hp-tr__word');
    if (!el || reduce) return;
    var words = (el.getAttribute('data-words') || '').split('|').map(function (w) { return w.trim(); }).filter(Boolean);
    if (words.length < 2) return;
    var i = 0;
    setInterval(function () {
      if (document.hidden) return;
      i = (i + 1) % words.length;
      el.textContent = words[i];
      el.classList.remove('is-in'); void el.offsetWidth; el.classList.add('is-in');
    }, 1500);
  }

  function marquee(root) {
    var box = root.querySelector('.hp-brands');
    pauseButton(root, function (p) { box.classList.toggle('is-paused', p); }, reduce);
  }

  // GA4 click tracking: a link inside an element with data-hp-ev sends that event with the JSON in data-hp-p.
  // Uses the Google tag the store already loads (so it follows cookie consent); does nothing if gtag is missing.
  // Labels are handles/ids/links so reports group the same click across English, French and Spanish.
  if (!window.hpTrackReady) {
    window.hpTrackReady = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      var el = a && a.closest('[data-hp-ev]');
      if (!el || typeof window.gtag !== 'function') return;
      try { window.gtag('event', el.getAttribute('data-hp-ev'), JSON.parse(el.getAttribute('data-hp-p') || '{}')); } catch (err) {}
    }, true);
  }

  var inits = { hero: hero, ftabs: ftabs, roll: roll, tabs: tabs, reviews: reviews, marquee: marquee, catmore: catmore, blog: blog, trustroll: trustroll };
  function init(scope) {
    scope.querySelectorAll('[data-hp]').forEach(function (el) {
      if (el.hpReady) return;
      el.hpReady = true;
      el.getAttribute('data-hp').split(' ').forEach(function (k) { inits[k] && inits[k](el); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
